import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ApplicationRoutes from './routes/ApplicationRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './hooks/useAuth';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
            <BrowserRouter>
                <AuthProvider>
                    <ApplicationRoutes />
                    <ToastContainer />
                </AuthProvider>
            </BrowserRouter>
        </GoogleOAuthProvider>
    );
}

export default App;
